import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../../service/api.service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationsService, NotificationType} from 'angular2-notifications';
import {Router, ActivatedRoute} from '@angular/router';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-convert-result',
  templateUrl: './convert-result.component.html',
  styleUrls: ['./convert-result.component.css']
})
export class ConvertResultComponent implements OnInit {
  @Input() app;

  @Output() deleteApp = new EventEmitter<any>();
  @Output() editAppType = new EventEmitter<any>();
  @Output() cancelAppeal = new EventEmitter<any>();

  loading: any;
  themeSubjects: any = [];
  isCollapsed = true;

  constructor(
    public api: ApiService,
    public router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private _notifications: NotificationsService,
    public translate: TranslateService) {
  }

  ngOnInit(): void {
    // this.PrintElem();
  }

  PrintElem() {
    let mywindow = window.open('', 'PRINT', 'height=400,width=600');
    mywindow.document.write('<html><head><title>' + document.title + '</title>');
    mywindow.document.write('</head><body >');
    // mywindow.document.write('<h1>' + document.title  + '</h1>');
    mywindow.document.write(document.getElementById('themes').innerHTML);
    mywindow.document.write('</body></html>');
    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }

  // getTheme(id: any, collapsed: any) {
  //   this.loading = true;
  //   if (collapsed == false) {
  //     this.api.getStatTheme(id)
  //       .subscribe((res: any) => {
  //         this.themeSubjects = res.items;
  //         this.themeSubjects.sort((a, b) => a.ord > b.ord ? 1 : -1);
  //         this.loading = false;
  //       }, (err: any) => {
  //         this.translate.currentLang == 'ru' ? this._notifications.create('Ошибка', err.error.errorMessage.ru, NotificationType.Error,
  //           5000) : this._notifications.create('Қате', err.error.errorMessage.kk, NotificationType.Error, 5000);
  //         this.loading = false;
  //       });
  //   }
  // }

  checkCertificate(id, iin, testPeriodYear, testType) {
    this.loading = true;
    this.api.checkCertificatecheck(id, iin, testPeriodYear, testType)
      .subscribe((res: any) => {
        if (res.data.isExists) {
          this.api.downloadCertificate(id, iin, testPeriodYear, testType)
            .subscribe((res: any) => {
              // let certifLink = res.data.certificateDownLoadUrl;
              // window.open(certifLink, "_blank");
              window.location.href = res.data.certificateDownLoadUrl;
              this.loading = false;
            });
        } else {
          this.translate.currentLang == 'ru' ? this._notifications.create('Ошибка', 'сертификат еще не доступен', NotificationType.Error,
            5000) : this._notifications.create('Қате', 'Сертификатыңыз әлі дайын емес', NotificationType.Error, 5000);
          this.loading = false;
        }
      }, (err: any) => {
        this.loading = false;
      });
  }
}
